import { BaseComponent } from "../base.component";
import {
  Component,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { ModalDirective } from "ng-uikit-pro-standard";
import { FormGroup, FormControl } from "@angular/forms";
import { JobService } from "../../service/job.service";
import { UploadingImage } from "@npm.chapps.com/chapps.common.angular.library/lib/components/others/image-cropper/model/uploading-image";
import {ChappsImageCropperComponent} from '@npm.chapps.com/chapps.common.angular.library';
import {forkJoin} from 'rxjs';

@Component({
  selector: "app-decline-modal",
  templateUrl: "./decline-modal.component.html",
  styleUrls: ["./decline-modal.component.scss"]
})
export class DeclineModalComponent extends BaseComponent {
  public formGroup: FormGroup;
  public showUnsupportedFileExtensionMessage: boolean;
  public completed: boolean;
  public showFileUploadErrorMessage: boolean;
  public photos: any[];
  public multimedia: any[];
  private supportedFileTypes: string[];

  @ViewChild(ChappsImageCropperComponent)
  chappsImageCropperComponent: ChappsImageCropperComponent;
  @ViewChild("modal") modal: ModalDirective;

  @Input() id: string;
  @Input() ids: string[] = [];
  @Input() type: string;
  @Input() readonly: boolean;
  @Output() success: EventEmitter<null> = new EventEmitter<null>();
  public submitting: boolean;

  public get feedbackFC() {
    return this.formGroup.get("feedback");
  }

  constructor(
    private jobService: JobService
  ) {
    super();
  }

  ngOnInit() {
    this.supportedFileTypes = ["image/jpeg", "image/png"];
    this.photos = [];
    this.multimedia = [];
    this.initForm();
    this.resetForm();
  }

  private initForm() {
    this.formGroup = new FormGroup({
      feedback: new FormControl(null)
    });
  }

  private resetForm() {
    this.formGroup.setValue({
      feedback: null
    });
  }

  private get allJobs(): string[] {
    if(this.ids.length === 0){
      return [this.id]
    }else{
      return [this.id, ...this.ids].filter(id => !!id);
    }
  }

  public get hasMultipleJobs(): boolean {
    return this.ids?.length > 1;
  }

  public decline() {
    this.submitting = true;
    forkJoin(
      this.allJobs.map(job => this.jobService.declineJob(
        job,
        this.formGroup.controls.feedback.value,
        this.multimedia
      ))
    ).subscribe(success => {
      this.submitting = false;
      if (success) {
        this.completed = true;
      }
    });
  }

  public show() {
    this.modal.show();
  }

  public hide() {
    this.modal.hide();
    if (this.completed) {
      this.success.emit(null);
    }
  }

  public fileCropped(croppedFile: UploadingImage) {
    this.convertFileToUrl(croppedFile.modifiedFile, this.photos.length);
  }

  private convertFileToUrl(file: File, index: number) {
    this.multimedia[index] = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => (this.photos[index] = reader.result);
  }

  public onPhotoDelete(index: number) {
    this.photos.splice(index, 1);
    this.multimedia.splice(index, 1);
  }

  public onPhotoSelected(files: File[]) {
    this.showFileUploadErrorMessage = false;
    this.showUnsupportedFileExtensionMessage = false;
    if (files.length) {
      const file: File = files[0];
      if (this.supportedFileTypes.indexOf(file.type) !== -1) {
        this.chappsImageCropperComponent.computeImages([file]);
      } else {
        this.showUnsupportedFileExtensionMessage = true;
      }
    }
  }
}
